import { PublicKey } from '@solana/web3.js';

export * from './gem-bank';
export * from './gem-farm';
export * from './gem-common';

export const GEM_BANK_PROG_ID = new PublicKey(
  'AeBguYJSBwHwxzj4xnLtk58gMcYtV6wpQdZX5DtdA55'
);
export const GEM_FARM_PROG_ID = new PublicKey(
  '7NryUmAmy8hMbawRNUs9UdkgAGEiHFxghSfve31dC7xh'
);
